import React from 'react';
import type { IntelSource } from '../../../types/intel-source.js';
import { Button } from '../../../components/ui';
import { isStale } from './source-freshness.js';

/**
 * BulkFooter — the DataTable footer row (demo /tables/data-tables footer): "Showing N of M" with the bulk actions
 * once rows are selected, and the discovered / stale counts on the right.
 */
interface BulkFooterProps {
  total: number;
  shown: number;
  selectedCount: number;
  sources: IntelSource[];
  fetchPending: boolean;
  deactivatePending: boolean;
  onBatchFetch: () => void;
  onBatchDeactivate: () => void;
}

export const BulkFooter: React.FC<BulkFooterProps> = ({
  total,
  shown,
  selectedCount,
  sources,
  fetchPending,
  deactivatePending,
  onBatchFetch,
  onBatchDeactivate,
}) => {
  const discoveredCount = sources.filter((s) => !s.seed && s.discoveredAt != null).length;
  const staleCount = sources.filter(isStale).length;

  return (
    <div className="flex w-full flex-wrap items-center justify-between gap-2 text-xs text-muted">
      <span className="flex flex-wrap items-center gap-2">
        {`Showing ${shown} of ${total}`}
        {selectedCount > 0 && (
          <>
            <span className="text-body">{selectedCount} selected</span>
            <Button variant="ghost" size="sm" onClick={onBatchFetch} loading={fetchPending}>
              Fetch selected
            </Button>
            <Button variant="ghost" size="sm" onClick={onBatchDeactivate} loading={deactivatePending}>
              Deactivate selected
            </Button>
          </>
        )}
      </span>
      <span>
        {discoveredCount > 0 && `${discoveredCount} discovered`}
        {discoveredCount > 0 && staleCount > 0 && ' · '}
        {staleCount > 0 && `${staleCount} stale`}
      </span>
    </div>
  );
};
